import Pagination from "../../entities/Pagination";
import {action, computed, makeObservable, observable, runInAction} from "mobx";
import CommonStore from "../../stores/CommonStore";
import ArticleCategory from "../../entities/productOrder/article/ArticleCategory";
import { ArticleCategoryService } from "../../service/articleDelivery/ArticleCategoryService";

class ArticleCategoryStore {

    public articleCategories: ArticleCategory[];
    public pagination: Pagination;
    public filter?: string;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore) {
        this.pagination = new Pagination(1, 15, 0, 0);
        this.articleCategories = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            articleCategories: observable,
            pagination: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.articleCategories.length === 0;
    }

    public setFilter(filter: string) {
        this.filter = filter;
    }

    @action
    public async search() {
        await this.getElements(1);
    }


    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getElements(page, pageSize);
    }

    @action
    public async getElements(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.commonStore.setLoading();
        const response = await ArticleCategoryService.get(page, pageSize, this.filter);
        if (response.success) {
            runInAction(() => {
                this.articleCategories = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

}

export default ArticleCategoryStore;

